import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { tmobilejPortoutColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPortout } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "msisdn",
  "extra_data.port_out_pin",
  "status",
  "created_at",
  "last_updated",
];

const TmobilejPortoutBatch = () => (
  <BatchDetail
    title="Portout"
    apiGet={__getPortout}
    client={CLIENTS.tmobilej}
    columnsFactory={tmobilejPortoutColumns}
    copyKeys={COPY_KEYS}
    exportAction="portout"
    retryOperation="portout"
    showTerminate
    getRowPath={(row) => `/tmobilej/portout/${row.id}`}
  />
);

export default TmobilejPortoutBatch;
